import(/* webpackMode: "eager", webpackExports: ["ConvexAuthNextjsClientProvider"] */ "/Users/jerrod.a/Documents/Haulbase.ai/node_modules/@convex-dev/auth/dist/nextjs/client.js");
;
import(/* webpackMode: "eager" */ "/Users/jerrod.a/Documents/Haulbase.ai/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/Users/jerrod.a/Documents/Haulbase.ai/src/components/analytics/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvexClientProvider"] */ "/Users/jerrod.a/Documents/Haulbase.ai/src/components/convex-client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingAnalytics"] */ "/Users/jerrod.a/Documents/Haulbase.ai/src/components/marketing/MarketingAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HelpWidget"] */ "/Users/jerrod.a/Documents/Haulbase.ai/src/components/support/HelpWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantContextProvider"] */ "/Users/jerrod.a/Documents/Haulbase.ai/src/components/tenant/TenantContextProvider.tsx");
